"use client";
import React, { useState, useRef } from "react";
import Tabs from "components/common/Tabs";
import TabTimeFrame from "./TabTimeFrame";
import TabAppointment from "./TabAppointment";
import { ClientOnly } from "components/common";
import Loading from "components/common/Loading";
// import UnconfirmedAppointmentBadge from "components/home/UnconfirmedAppointmentBadge";
import MoreActionsModal, { MoreActionsModalRef } from "./MoreActionsModal";
import { useSearchParams, useRouter, usePathname } from "next/navigation";

const SectionContent = ({
  onAccept,
  isLoading = false,
}: {
  onAccept?: (booking: any) => void;
  isLoading?: boolean;
}) => {
  const searchParams = useSearchParams();
  const router = useRouter();
  const pathname = usePathname();
  const moreActionsModalRef = useRef<MoreActionsModalRef>(null);

  // Local state for active tab
  const validTabs = ['time-frame', 'appointment'];
  const defaultTab = 'time-frame';
  const tabFromUrl = searchParams.get('tab');
  const initialTab = tabFromUrl && validTabs.includes(tabFromUrl) ? tabFromUrl : defaultTab;

  const [activeTab, setActiveTab] = useState(initialTab);

  // Handle tab change - update URL
  const handleTabChange = (tabKey: string) => {
    setActiveTab(tabKey);
    // Update URL with new tab parameter
    const params = new URLSearchParams(searchParams.toString());
    params.set('tab', tabKey);
    router.push(`${pathname}?${params.toString()}`, { scroll: false });
  };

  const handleMoreActions = (booking: any) => {
    moreActionsModalRef.current?.open(booking);
  };
  return (
    <div className="flex flex-col h-full w-full bg-gray-01">
      {/* <UnconfirmedAppointmentBadge /> */}
      <Tabs
        rootClassName="flex-1 h-full"
        activeKey={activeTab}
        type="card"
        onChange={handleTabChange}
        items={[
          {
            id: "view-by",
            className: "bg-transparent border-none pointer-events-none",
            key: "view-by",
            label: "Xem theo",
            disabled: true,
          },
          {
            label: "Khung giờ",
            key: "time-frame",
            children: (
              <div className="h-full overflow-y-auto">
                {isLoading ? (
                  <div className="flex items-center justify-center h-full bg-white">
                    <Loading text="Đang tải..." />
                  </div>
                ) : (
                  <TabTimeFrame onAccept={onAccept} onMore={handleMoreActions} />
                )}
              </div>
            ),
          },
          {
            id: "appointment",
            label: "Lịch hẹn",
            key: "appointment",
            children: (
              <div className="h-full overflow-y-auto">
                {isLoading ? (
                  <div className="flex items-center justify-center h-full bg-white">
                    <Loading text="Đang tải..." />
                  </div>
                ) : (
                  <TabAppointment onAccept={onAccept} onMore={handleMoreActions} />
                )}
              </div>
            ),
          },
        ]}
      />
      <MoreActionsModal ref={moreActionsModalRef} onSuccess={onAccept} />
    </div>
  );
};

export default function Wrapper({
  onAccept,
  isLoading = false,
}: {
  onAccept?: (booking: any) => void;
  isLoading?: boolean;
}) {
  return (
    <ClientOnly>
      <SectionContent onAccept={onAccept} isLoading={isLoading} />
    </ClientOnly>
  );
}
